<template>
  <div>
    User Views Main
  </div>
</template>

<script>
// import List from "../components/List";
export default {
  name: 'user-views-main',
  data() {
    return {
    };
  },
  // components: {
  //   List
  // }
};
</script>

<style scoped></style>

